import { MAP_EMPLOYEE_STATUS } from '../constants';
import { useFieldHelper } from 'framework/ui/field';
import { Badge } from 'framework/ui/mui-builder';
import { SxProps } from '@mui/material';
import { BadgeLayoutProps } from 'framework/ui/uiContract';

const commonChipStyles = {
  fontSize: '8px',
  textTransform: 'capitalize',
};

const STATUS_COLORS: Record<keyof typeof MAP_EMPLOYEE_STATUS, BadgeLayoutProps['color']> = {
  ACTIVE: 'success',
  PROBATION: 'primary',
  IN_DISMISSAL: 'warning',
  DISMISSAL: 'warning',
  DISMISSED: 'default',
  RELOCATION: 'secondary',
};

interface WorkingStatusChipProps {
  source?: string;
  sx?: SxProps;
  props?: any;
}
const WorkingStatusChip = ({ source = 'employeeStatus', sx, ...props }: WorkingStatusChipProps) => {
  const { getValue } = useFieldHelper<keyof typeof MAP_EMPLOYEE_STATUS>({ source });
  const status = getValue();

  const color: BadgeLayoutProps['color'] =
    status in STATUS_COLORS ? STATUS_COLORS[status as keyof typeof STATUS_COLORS] : 'default';

  return (
    <Badge
      color={color}
      sx={{
        ...commonChipStyles,
        ...sx,
      }}
      isVisible={!!status}
      {...props}
    >
      {MAP_EMPLOYEE_STATUS[status]}
    </Badge>
  );
};

export default WorkingStatusChip;
